import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import EmailTemplate from './../../../../../models/EmailTemplate';
import { withTranslation } from "react-i18next";
import { Icon, Menu, Tooltip } from 'antd';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
const ListCols = ['titleEmail', 'status'];
const ModelFields = Object.getOwnPropertyNames(new EmailTemplate());
class EmailTemplateList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                titleEmail: {
                    key: 'title',
                    render: (text, record) => <EllipsisText title={record.title} content={record.title} contentMaxWidth={400}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                status: {
                    key: 'isActive',
                    render: (text, record) => (
                        <StatusComponent color={record.isActive ? 'green' : 'red'}
                            label={record.isActive ? this.props.t('item.emailTemplate.isActived') : this.props.t('item.emailTemplate.isUnactived')} />
                    )
                },
                // translations: {
                //     key: 'languageCode',
                //     filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                //         value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                //     })),
                //     filterMultiple: false,
                //     width: 120,
                //     render: (text, record) => <FlagIcons languages={record.translations} />,
                // },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, emailTemplates } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="email-template-list"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(emailTemplates || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'emailTemplate'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeItem = () => {
            return this.props.onDeleteEmailTemplate && this.props.onDeleteEmailTemplate(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.emailTemplate.title`)),
                content: item.title,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>

                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.EMAIL_TEMPLATE.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }

                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }


}

export default withTranslation()(EmailTemplateList);
